import { useTheme } from '@emotion/react';
import { Button, Menu, MenuItem, Stack, Switch, Typography, colors } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { initCompanyDetails, initTraderDetails, initUserData } from '../../../../redux/features/authSlice';
import { showmessage } from '../../../../utils/toastr';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';
import { CancelToken } from 'apisauce';

export default function NotificationSetting() {
  const theme = useTheme();
  let source = CancelToken.source();

  const { t } = useTranslation();
  const { userId, companyDetails, user } = useSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const useIsMount = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
      isMountRef.current = false;
    }, []);
    return isMountRef.current;
  };

  const isMount = useIsMount();

  const [data, setData] = useState({
    lowBalance: user?.notification?.lowBalance === false ? user?.notification?.lowBalance : true,
    lowBalanceThreshHold: user?.notification?.lowBalanceThreshHold ? user?.notification?.lowBalanceThreshHold : 10,
    tradeAdvisory: user?.notification?.tradeAdvisory === false ? user?.notification?.tradeAdvisory : true,
    screening: user?.notification?.screening === false ? user?.notification?.screening : true,
    reportVerification: user?.notification?.reportVerification === false ? user?.notification?.reportVerification : true,
    allNotification: user?.notification?.allNotification === false ? user?.notification?.allNotification : true,
  });

  const [dataTrader, setDataTrader] = useState({
    quoteRequest: user?.traderNotification?.quoteRequest === false ? user?.traderNotification?.quoteRequest : true,
    quoteStatus: user?.traderNotification?.quoteStatus === false ? user?.traderNotification?.quoteStatus : true,
  });

  const handleNotification = async (values) => {
    const payload = {
      notification: {
        lowBalance: data?.lowBalance,
        lowBalanceThreshHold: data?.lowBalanceThreshHold,
        tradeAdvisory: data?.tradeAdvisory,
        screening: data?.screening,
        reportVerification: data?.reportVerification,
        allNotification: data?.allNotification,
      },
    };
    source.cancel();
    source = CancelToken.source();
    dispatch(setLoading(true));
    const response = await appapi.put(`user-management/notification/${userId}`, payload, { cancelToken: source.token });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        handleMenuClose();
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleNotificationTrader = async (values) => {
    const payload = {
      traderNotification: {
        quoteRequest: dataTrader?.quoteRequest === false ? dataTrader?.quoteRequest : true,
        quoteStatus: dataTrader?.quoteStatus === false ? dataTrader?.quoteStatus : true,
      },
    };
    source.cancel();
    source = CancelToken.source();
    dispatch(setLoading(true));
    const response = await appapi.put(`user-management/traderNotification/${userId}`, payload, { cancelToken: source.token });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        handleMenuClose();
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  useEffect(() => {
    dispatch(initUserData());
    if (!isMount) {
      if (user.type === 'trader') {
        handleNotificationTrader();
        dispatch(initUserData());
        return () => {
          if (source) {
            source.cancel();
          }
        };
      } else {
        handleNotification();
        dispatch(initUserData());
        return () => {
          if (source) {
            source.cancel();
          }
        };
        // }
      }
    }

    // eslint-disable-next-line
  }, [data?.lowBalance, data?.lowBalanceThreshHold, data?.screening, data?.allNotification, data?.tradeAdvisory, data?.reportVerification, dataTrader?.quoteRequest, dataTrader?.quoteStatus]);

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const formRef = useRef();
  return (
    <Stack>
      <Stack
        style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
        className="my-[15px] p-[16px] mx-[15px]"
        flex={1}
      >
        <Typography
          className="fw-regular ff-Roboto fs-16"
          color={text}
        >
          {t('Notifications')}
        </Typography>
        <Typography
          className="fw-regular ff-Roboto fs-12 !mb-[16px]"
          color={textLight}
        >
          {t('Some info may be visible to other people using ZeroEmission services')}
        </Typography>
        {user.type === 'trader' ? (
          <Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Switch
                  checked={dataTrader?.quoteRequest}
                  onChange={() => {
                    setDataTrader((prev) => ({ ...prev, quoteRequest: !dataTrader?.quoteRequest }));
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography
                  className="fw-medium ff-Roboto fs-14 capitalize"
                  color={'#14285A'}
                >
                  {t('Quote request')}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Switch
                  checked={dataTrader?.quoteStatus}
                  onChange={() => {
                    setDataTrader((prev) => ({ ...prev, quoteStatus: !dataTrader?.quoteStatus }));
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography
                  className="fw-medium ff-Roboto fs-14 capitalize"
                  color={'#14285A'}
                >
                  {t('Quote status')}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        ) : (
          <Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Switch
                  disabled={data?.allNotification}
                  checked={data?.lowBalance}
                  onChange={() => {
                    setData((prev) => ({ ...prev, lowBalance: !data.lowBalance }));
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography
                  className="fw-medium ff-Roboto fs-14 capitalize"
                  color={'#14285A'}
                >
                  {t('Low EUA balance')}
                </Typography>
              </Stack>
            </Stack>
            <Stack className="ml-[45px]">
              <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: '#14285A',
                    fontSize: '12px',
                    textTransform: 'capitalize',
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                      // borderColor: theme.palette.secondary.main,
                    },
                  },
                ]}
                style={{ width: '148px' }}
                onClick={handleMenuOpen}
                endIcon={anchorEl ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              >
                {t('Select threshold')}
              </Button>
              <Menu
                className="appbar"
                id="resource-menu"
                anchorEl={anchorEl}
                open={open}
                MenuListProps={{
                  'aria-labelledby': 'resource-button',
                }}
                onClose={handleMenuClose}
                PopperProps={{
                  placement: 'bottom-end',
                }}
                PaperProps={{
                  style: {
                    width: '120px',
                    marginRight: '25px',
                  },
                }}
              >
                <MenuItem
                  className="ff-Roboto fs-12 fs-medium"
                  style={{ color: 'black', minHeight: '32px', backgroundColor: data?.lowBalanceThreshHold === 10 ? '#F2F3F580' : null }}
                  onClose={handleMenuClose}
                  onClick={() => {
                    setData((prev) => ({ ...prev, lowBalanceThreshHold: 10 }));
                  }}
                >
                  {t('10%')}
                </MenuItem>
                <MenuItem
                  className="ff-Roboto fs-12 fs-medium"
                  style={{ color: 'black', minHeight: '32px', backgroundColor: data?.lowBalanceThreshHold === 20 ? '#F2F3F580' : null }}
                  onClose={handleMenuClose}
                  onClick={() => {
                    setData((prev) => ({ ...prev, lowBalanceThreshHold: 20 }));
                  }}
                >
                  {t('20%')}
                </MenuItem>
                <MenuItem
                  className="ff-Roboto fs-12 fs-medium"
                  style={{ color: 'black', minHeight: '32px', backgroundColor: data?.lowBalanceThreshHold === 30 ? '#F2F3F580' : null }}
                  onClose={handleMenuClose}
                  onClick={() => {
                    setData((prev) => ({ ...prev, lowBalanceThreshHold: 30 }));
                  }}
                >
                  {t('30%')}
                </MenuItem>
              </Menu>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Switch
                  disabled={data?.allNotification}
                  checked={data?.tradeAdvisory}
                  onChange={() => {
                    setData((prev) => ({ ...prev, tradeAdvisory: !data?.tradeAdvisory }));
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography
                  className="fw-medium ff-Roboto fs-14 capitalize"
                  color={'#14285A'}
                >
                  {t('Trader advisory')}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Switch
                  disabled={data?.allNotification}
                  checked={data?.screening}
                  onChange={() => {
                    setData((prev) => ({ ...prev, screening: !data?.screening }));
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography
                  className="fw-medium ff-Roboto fs-14 "
                  color={'#14285A'}
                >
                  {t('Screening')}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Switch
                  disabled={data?.allNotification}
                  checked={data?.reportVerification}
                  onChange={() => {
                    setData((prev) => ({ ...prev, reportVerification: !data?.reportVerification }));
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography
                  className="fw-medium ff-Roboto fs-14 capitalize"
                  color={'#14285A'}
                >
                  {t('Report verification')}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        )}
      </Stack>
      {user?.type != 'trader' && (
        <Stack className="mx-[15px]">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={'#8993AC'}
          >
            {t('You may also disable all optional notifications, but it is not advisable')}
          </Typography>
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Switch
              checked={data?.allNotification}
              onChange={() => {
                setData((prev) => ({ ...prev, allNotification: !data?.allNotification, lowBalance: data?.allNotification ? false : true, tradeAdvisory: data?.allNotification ? false : true, screening: data?.allNotification ? false : true, reportVerification: data?.allNotification ? false : true }));
              }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography
              className="fw-regular ff-Roboto fs-14"
              color={'#14285A'}
            >
              {t('All optional notifications')}
            </Typography>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
